<template>
    <div>
        <div v-if="$store.getters.POPUP" class="pop-up-bg d-flex justify-content-center align-items-center"
            v-on:click="closePopUp">
            <div class="pop-up">
                <b-icon class="mb-4" :icon="iconArr[$store.getters.POPUP - 1][0]" :variant="iconArr[$store.getters.POPUP - 1][1]"
                    font-scale="4"></b-icon>
                <!-- <b-icon v-if="$store.getters.POPUP === 2" class="mb-4" icon="exclamation-circle-fill" variant="warning"
                    font-scale="4"></b-icon>
                <b-icon v-if="$store.getters.POPUP === 3" class="mb-4" icon="x-circle-fill" variant="danger"
                    font-scale="4"></b-icon> -->
                <h1 v-if="$store.getters.POPUPTITLE">{{ $store.getters.POPUPTITLE }} </h1>
                <h3 v-if="$store.getters.POPUPTEXT" v-html="$store.getters.POPUPTEXT"> </h3>
            </div>
        </div>
    </div>
</template>
<script>
// import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            iconArr: [
            ['check-circle-fill', 'success'],
            ['exclamation-circle-fill', 'warning'],
            ['x-circle-fill', 'danger']
            ]
        }
    },
    // computed: {
    //     ...mapGetters({
    //         myState: 'getMyState'
    //     })
    // },
    methods: {
        closePopUp() {
            window.scrollTo(0, 0);
            this.$store.commit('popUpWiev', false);
            // this.LocalPopUp = false;
        }
        // ,
        // copyProps() {
        //     this.LocalPopUp = this.$attrs.popUp;
        //     this.LocalPopUpTitle = this.$attrs.popUpTitle;
        //     this.LocalPopUpText = this.$attrs.popUpText;
        // }
    }
    // ,
    // watch: {
    //     $store: {
    //         handler: function (val, oldVal) {
    //             if (val.popUp !== oldVal.popUp) {
    //                 this.copyProps();
    //             }
    //         }
    //     },
    //     deep: true
    // }
}
</script>
<style>
.pop-up-bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgb(221, 212, 226);
    z-index: 9999;
    overflow: auto;
}

.pop-up {
    border-radius: 0.375rem;
    width: 80%;
    padding: 40px;
    position: absolute;
    text-align: center;
    background-color: rgb(232, 231, 231);
}

.pop-up h1,
.pop-up h3,
.pop-up-bg {
    cursor: pointer;
}
</style>